import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "inAppNotification",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "text",
        innerHTML: _ctx.item.text
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$filters.date(_ctx.item.createdOn, 'DD-MM-YY HH:mm')), 1)
  ]))
}